import React from "react";

import { useTranslation } from "react-i18next";
import { LockOutlined } from "@/icons";
import AnimatedEntrance from "@/views/common/AnimatedEntrance";
import { Text } from '@datanomik/core-ui';

/** Shown by CashPoolingAccessGuard when the current user has no cash-pooling role. */
export const CashPoolingUnauthorizedPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <AnimatedEntrance>
      <div className="flex flex-col items-center justify-center h-full w-full min-h-125">
        <div className="flex flex-col items-center justify-center max-w-[420px] w-full gap-5 m-auto">
          <div className="flex flex-col items-center justify-center w-[80px] h-[80px] rounded-full bg-primary-subtle text-primary">
            <LockOutlined size={40} />
          </div>
          <Text variant="title-sm" weight="medium" className="text-center">
            {t("No access to Cash Pooling")}
          </Text>
          <Text tone="muted" className="text-center" style={{
            maxWidth: "320px",
          }}>
            {t("You do not have permission to use the Cash Pooling module. Contact an administrator to request access.")}
          </Text>
        </div>
      </div>
    </AnimatedEntrance>
  );
};
